import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor() { }

  private unreadEvent = new EventEmitter();

  public getUnreadEvent() {
    return this.unreadEvent;
  }
}
